
import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { Action, State } from "vuex-class";

import { TracerStudyQuestionsModel } from "@/models/tracerstudy.model";

@Component
export default class ModalResponseIndividual extends Vue {
  /* VUEX */

  /* ACTION */
  @Action("actionTracerStudyQuestion", { namespace: "tracerstudy" })
  private actionTracerStudyQuestion: any;

  /* STATE */
  @State("tracer_study_questions", { namespace: "tracerstudy" })
  private tracer_study_questions: Array<TracerStudyQuestionsModel>;

  /* INITIALIZATION */
  private created() {
    this.loadQuestion();
  }

  /* METHODS */
  private loadQuestion() {
    const { tracer_id } = this.$route.params;
    this.actionTracerStudyQuestion({
      params: { tracer_id },
    });
  }
}
